import { useEffect, useState } from "react";

export function P1(props: any) {
    const [className, setclassName] = useState("");
    useEffect(() => {
        let _className = "loop-text-p1";
        if (props.className) {
            _className += " " + props.className;
        }
        setclassName(_className);
    }, [props.className]);

    return (
        <div className={className} style={props.style ? props.style : {}}>
            {props.children}
        </div>
    );
}

export function P2(props: any) {
    const [className, setclassName] = useState("");
    useEffect(() => {
        let _className = "loop-text-p2";
        if (props.className) {
            _className += " " + props.className;
        }
        setclassName(_className);
    }, [props.className]);

    return (
        <div className={className} style={props.style ? props.style : {}}>
            {props.children}
        </div>
    );
}

export function P3(props: any) {
    const [className, setclassName] = useState("");
    useEffect(() => {
        let _className = "loop-text-p3";
        if (props.className) {
            _className += " " + props.className;
        }
        setclassName(_className);
    }, [props.className]);

    return (
        <div className={className} style={props.style ? props.style : {}}>
            {props.children}
        </div>
    );
}

export default Object.assign(
    {},
    {
        P1: P1,
        P2: P2,
        P3: P3,
    },
);
